import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_FormVector3D = _resolveComponent("FormVector3D");
    const _component_FormInput = _resolveComponent("FormInput");
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createVNode(_component_FormWrapper, {
            label: _ctx.regionsInTree ? 'Load from Sphere or Box Region' : undefined,
            disabled: _ctx.disabled
        }, {
            default: _withCtx(() => [
                (_ctx.regionsInTree)
                    ? (_openBlock(), _createBlock(_component_FormSelect, {
                        key: 0,
                        disabled: _ctx.disabled,
                        options: _ctx.regionsInTree,
                        modelValue: _ctx.selectedRegionId,
                        onOnChange: _ctx.onRegionSelected
                    }, null, 8, ["disabled", "options", "modelValue", "onOnChange"]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["label", "disabled"]),
        (_ctx.isBox)
            ? (_openBlock(), _createBlock(_component_FormWrapper, {
                key: 0,
                label: _ctx.regionNameToUse + 'Dimensions (X, Y, Z)',
                disabled: _ctx.disabled
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_FormVector3D, {
                        modelValue: _ctx.modelValueToUse.dimensions,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.modelValueToUse.dimensions) = $event)),
                        id: 'dimens-' + _ctx.id,
                        disabled: _ctx.disabled,
                        description: _ctx.description,
                        onOnChange: _ctx.resetSelected,
                        styl: "padding-left: 12px; padding-right: 12px;",
                        delayBetweenChangesDetected: 0
                    }, null, 8, ["modelValue", "id", "disabled", "description", "onOnChange"])
                ]),
                _: 1
            }, 8, ["label", "disabled"]))
            : (_openBlock(), _createBlock(_component_FormWrapper, {
                key: 1,
                label: _ctx.regionNameToUse + 'Radius',
                disabled: _ctx.disabled
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_FormInput, {
                        modelValue: _ctx.modelValueToUse.radius,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.modelValueToUse.radius) = $event)),
                        id: _ctx.id + '-radius',
                        disabled: _ctx.disabled,
                        description: _ctx.description,
                        styl: "padding-left: 12px; padding-right: 12px;",
                        onOnChange: _ctx.resetSelected,
                        placeHolder: "Radius..."
                    }, null, 8, ["modelValue", "id", "disabled", "description", "onOnChange"])
                ]),
                _: 1
            }, 8, ["label", "disabled"])),
        _createVNode(_component_FormWrapper, {
            label: _ctx.regionNameToUse + 'Center (X, Y, Z)',
            disabled: _ctx.disabled
        }, {
            default: _withCtx(() => [
                _createVNode(_component_FormVector3D, {
                    modelValue: _ctx.modelValueToUse.center,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.modelValueToUse.center) = $event)),
                    id: 'center-' + _ctx.id,
                    disabled: _ctx.disabled,
                    description: _ctx.description,
                    onOnChange: _ctx.resetSelected,
                    styl: "padding-left: 12px; padding-right: 12px;",
                    delayBetweenChangesDetected: 0
                }, null, 8, ["modelValue", "id", "disabled", "description", "onOnChange"])
            ]),
            _: 1
        }, 8, ["label", "disabled"]),
        _createVNode(_component_FormElementDescription, {
            description: _ctx.description,
            warning: _ctx.warningToUse
        }, null, 8, ["description", "warning"])
    ]));
}
